import { c as _c } from "react/compiler-runtime";
import { useViewport } from '@sbt-web/hooks';
import { ListFilter, RangeFilter } from '@sbt-web/network/types';
import { FormGroup, SelectBox, SelectBoxSkeleton, SelectOption, SelectOptionOptionType } from '@sbt-web/ui';
import { mapValuesToOptions, useValueList, ValueListStatus } from '@/client/hooks/useValueList';
import { FilterLabel } from '../common/FilterLabel';
import type { CommonFilterProps } from '../common/types';
import styles from './range-selector.module.scss';
type Props = CommonFilterProps & {
  filter: RangeFilter;
  initialValues: {
    min?: string;
    max?: string;
  };
  onSelect: (key: string, value?: string, label?: string) => void;
};
export const RangeSelector = props => {
  const $ = _c(30);
  const {
    filter,
    initialValues,
    showBadgeNew,
    onSelect
  } = props;
  const {
    isMobile
  } = useViewport();
  let t0;
  if ($[0] !== onSelect) {
    t0 = (filter_0, option) => {
      onSelect(filter_0.queryString, option.length ? option[0].value : undefined, option.length ? option[0].name : undefined);
    };
    $[0] = onSelect;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSelection = t0;
  const flavor = isMobile ? "large" : "small";
  const minValueListData = useValueList(filter.min.dataSource);
  const maxValueListData = useValueList(filter.max.dataSource);
  if (minValueListData.state === ValueListStatus.ERROR || maxValueListData.state === ValueListStatus.ERROR) {
    return;
  }
  let currentMaxIndex;
  let currentMinIndex;
  let minValueListOptions;
  let t1;
  if ($[2] !== initialValues.max || $[3] !== initialValues.min || $[4] !== maxValueListData.value || $[5] !== minValueListData.value) {
    const minValueList = mapValuesToOptions(minValueListData.value);
    const maxValueList = mapValuesToOptions(maxValueListData.value);
    currentMinIndex = initialValues.min ? minValueList.findIndex(v => v.value === initialValues.min) : -1;
    const currentMinOption = currentMinIndex >= 0 ? minValueList[currentMinIndex] : undefined;
    currentMaxIndex = initialValues.max ? maxValueList.findIndex(v_0 => v_0.value === initialValues.max) : -1;
    const currentMaxOption = currentMaxIndex >= 0 ? maxValueList[currentMaxIndex] : undefined;
    const isMaxSet = currentMaxOption !== undefined;
    const isMinSet = currentMinOption !== undefined;
    minValueListOptions = minValueList.map(value => ({
      ...value,
      disabled: isMaxSet && (value.weight ?? 0) > (currentMaxOption.weight ?? 0)
    }));
    let t2;
    if ($[10] !== currentMinOption || $[11] !== isMinSet) {
      t2 = value_0 => ({
        ...value_0,
        disabled: isMinSet && (value_0.weight ?? 0) < (currentMinOption.weight ?? 0)
      });
      $[10] = currentMinOption;
      $[11] = isMinSet;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t1 = maxValueList.map(t2);
    $[2] = initialValues.max;
    $[3] = initialValues.min;
    $[4] = maxValueListData.value;
    $[5] = minValueListData.value;
    $[6] = currentMaxIndex;
    $[7] = currentMinIndex;
    $[8] = minValueListOptions;
    $[9] = t1;
  } else {
    currentMaxIndex = $[6];
    currentMinIndex = $[7];
    minValueListOptions = $[8];
    t1 = $[9];
  }
  const maxValueListOptions = t1;
  let t2;
  if ($[13] !== filter.label || $[14] !== showBadgeNew) {
    t2 = <FilterLabel showBadgeNew={showBadgeNew}>{filter.label}</FilterLabel>;
    $[13] = filter.label;
    $[14] = showBadgeNew;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== currentMaxIndex || $[17] !== currentMinIndex || $[18] !== filter.max || $[19] !== filter.min || $[20] !== flavor || $[21] !== handleSelection || $[22] !== maxValueListData.state || $[23] !== maxValueListOptions || $[24] !== minValueListData.state || $[25] !== minValueListOptions) {
    t3 = minValueListData.state === ValueListStatus.LOADED && maxValueListData.state === ValueListStatus.LOADED ? <div className={styles["range-selector"]}><SelectBox nullable={true} name={filter.min.uri} placeholder="Qualsiasi" inlineLabel={filter.min.label} selectedIndices={currentMinIndex >= 0 ? [currentMinIndex] : []} flavor={flavor} valueList={minValueListOptions} onSelect={opt => handleSelection(filter.min, opt)} /><SelectBox nullable={true} name={filter.max.uri} placeholder="Qualsiasi" inlineLabel={filter.max.label === "a" ? "   a" : filter.max.label} selectedIndices={currentMaxIndex >= 0 ? [currentMaxIndex] : []} flavor={flavor} valueList={maxValueListOptions} onSelect={opt_0 => handleSelection(filter.max, opt_0)} /></div> : <div className={styles["range-selector"]}><SelectBoxSkeleton flavor={flavor} /><SelectBoxSkeleton flavor={flavor} /></div>;
    $[16] = currentMaxIndex;
    $[17] = currentMinIndex;
    $[18] = filter.max;
    $[19] = filter.min;
    $[20] = flavor;
    $[21] = handleSelection;
    $[22] = maxValueListData.state;
    $[23] = maxValueListOptions;
    $[24] = minValueListData.state;
    $[25] = minValueListOptions;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  if ($[27] !== t2 || $[28] !== t3) {
    t4 = <FormGroup>{t2}{t3}</FormGroup>;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  return t4;
};